import axios from "axios";
import store from "@/store/store";
import router from "@/router";
import { EventBus } from "./bus";

let counter = 0;

const http = axios.create({
  baseURL: "/api"
});

http.CancelToken = axios.CancelToken;
http.isCancel = axios.isCancel;

http.interceptors.request.use(config => {
  if (store.state.auth.isAuth) {
    config.headers.common[
      "Authorization"
    ] = `Bearer ${store.state.auth.user.accessToken}`;
  }
  if (store.state.config.party) {
    config.headers["BoT-Party"] = store.state.config.party;
  }

  counter++;
  EventBus.$emit("showLoading");

  return config;
});

http.interceptors.response.use(
  function(response) {
    if (counter > 0 && --counter == 0) {
      EventBus.$emit("hideLoading");
    }
    return response;
  },
  function(error) {
    if (counter > 0 && --counter == 0) {
      EventBus.$emit("hideLoading");
    }
    if (error.response.status == 401) {
      router.replace({ name: "login" });
    } else {
      if (error.response.status >= 400) {
        if (error.response.data) {
          store.commit("error", error.response.data);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default http;
